import color from 'color';
import { BLUE_TABLE_IMAGE_URL, DARK_BLUE_TABLE_IMAGE_URL, DARK_GRAY_TABLE_IMAGE_URL, DARK_GREEN_TABLE_IMAGE_URL, DARK_PURPLE_TABLE_IMAGE_URL, GRAY_TABLE_IMAGE_URL, GREEN_TABLE_IMAGE_URL, LIGHT_GRAY_TABLE_IMAGE_URL, ORANGE_TABLE_IMAGE_URL, PINK_TABLE_IMAGE_URL, PURPLE_TABLE_IMAGE_URL, RED_TABLE_IMAGE_URL } from '../assets/themeTableAssetUrls';
export const ALL_THEME_TABLE_TYPES = [
    'green',
    'darkGreen',
    'blue',
    'darkBlue',
    'red',
    'orange',
    'pink',
    'purple',
    'darkPurple',
    'lightGray',
    'gray',
    'darkGray'
];
export function isThemeTableType(str) {
    return ALL_THEME_TABLE_TYPES.includes(str);
}
export const DEFAULT_THEME_TABLE_TYPE = 'green';
export const DEFAULT_TABLE_SHADOW_ALPHA = 0.1;
function createThemeTableProperties({ type, label, imageUrl, tableFeltColorNum, brightestHighlightColorNum, baseDarkenAmount = 0.3, railTextureBrightnessAmount = 1, feltBrightness }) {
    const tableRailSolidColorNum = color(tableFeltColorNum).darken(baseDarkenAmount).rgbNumber();
    const potBackgroundColorNum = color(tableFeltColorNum).mix(color(tableRailSolidColorNum)).rgbNumber();
    const inactiveTimerBarColorNum = color(brightestHighlightColorNum).lighten(0.25).rgbNumber();
    const winningHandNameBackgroundColorNum = color(brightestHighlightColorNum).darken(0.5).saturate(0.5).rgbNumber();
    const dealingMessageTextColor = color(inactiveTimerBarColorNum).hex();
    const dealingMessageShadowColor = color(winningHandNameBackgroundColorNum).hex();
    return {
        type,
        label,
        imageUrl,
        tableFeltColorNum,
        inactiveTimerBarColorNum,
        winningHandNameBackgroundColorNum,
        dealingMessageTextColor,
        dealingMessageShadowColor,
        tableRailSolidColorNum,
        potBackgroundColorNum,
        railTextureBrightnessAmount,
        feltBrightness
    };
}
// Colors are sampled in Photoshop (eye-dropper tool).
// tableFeltColorNum: sampled from one of the dark bands, near the middle of the table
// brightestHighlightColorNum: sampled from the brightest highlight/band near the upper left
export const ALL_THEME_TABLE_PROPERTIES = {
    green: createThemeTableProperties({
        type: 'green',
        label: 'Green',
        imageUrl: GREEN_TABLE_IMAGE_URL,
        tableFeltColorNum: 0x21833b,
        brightestHighlightColorNum: 0x279a45
    }),
    darkGreen: createThemeTableProperties({
        type: 'darkGreen',
        label: 'Dark Green',
        imageUrl: DARK_GREEN_TABLE_IMAGE_URL,
        tableFeltColorNum: 0x144d23,
        brightestHighlightColorNum: 0x175e2a,
        railTextureBrightnessAmount: 0.7
    }),
    blue: createThemeTableProperties({
        type: 'blue',
        label: 'Blue',
        imageUrl: BLUE_TABLE_IMAGE_URL,
        tableFeltColorNum: 0x215d83,
        brightestHighlightColorNum: 0x266d98
    }),
    darkBlue: createThemeTableProperties({
        type: 'darkBlue',
        label: 'Dark Blue',
        imageUrl: DARK_BLUE_TABLE_IMAGE_URL,
        tableFeltColorNum: 0x123449,
        brightestHighlightColorNum: 0x17425c,
        railTextureBrightnessAmount: 0.7,
        feltBrightness: 0.5
    }),
    red: createThemeTableProperties({
        type: 'red',
        label: 'Red',
        imageUrl: RED_TABLE_IMAGE_URL,
        tableFeltColorNum: 0x963131,
        brightestHighlightColorNum: 0xb13b3b
    }),
    orange: createThemeTableProperties({
        type: 'orange',
        label: 'Orange',
        imageUrl: ORANGE_TABLE_IMAGE_URL,
        tableFeltColorNum: 0xe65b20,
        brightestHighlightColorNum: 0xef7627
    }),
    pink: createThemeTableProperties({
        type: 'pink',
        label: 'Pink',
        imageUrl: PINK_TABLE_IMAGE_URL,
        tableFeltColorNum: 0x97538b,
        brightestHighlightColorNum: 0xa9629c
    }),
    purple: createThemeTableProperties({
        type: 'purple',
        label: 'Purple',
        imageUrl: PURPLE_TABLE_IMAGE_URL,
        tableFeltColorNum: 0x54428a,
        brightestHighlightColorNum: 0x634ea2
    }),
    darkPurple: createThemeTableProperties({
        type: 'darkPurple',
        label: 'Dark Purple',
        imageUrl: DARK_PURPLE_TABLE_IMAGE_URL,
        tableFeltColorNum: 0x362b59,
        brightestHighlightColorNum: 0x43356d,
        railTextureBrightnessAmount: 0.7,
        feltBrightness: 0.5
    }),
    lightGray: createThemeTableProperties({
        type: 'lightGray',
        label: 'Light Gray',
        imageUrl: LIGHT_GRAY_TABLE_IMAGE_URL,
        tableFeltColorNum: 0x7c848d,
        brightestHighlightColorNum: 0x8b929a,
        baseDarkenAmount: 0.5
    }),
    gray: createThemeTableProperties({
        type: 'gray',
        label: 'Gray',
        imageUrl: GRAY_TABLE_IMAGE_URL,
        tableFeltColorNum: 0x4e5660,
        brightestHighlightColorNum: 0x5b6570
    }),
    darkGray: createThemeTableProperties({
        type: 'darkGray',
        label: 'Dark Gray',
        imageUrl: DARK_GRAY_TABLE_IMAGE_URL,
        tableFeltColorNum: 0x24282c,
        brightestHighlightColorNum: 0x32373d,
        baseDarkenAmount: 0.5,
        railTextureBrightnessAmount: 0.7
    })
};
